import { Component, Input } from '@angular/core';
import { NavItem } from '@schema/nav.models';

@Component({
  selector: 'lgv-navigation-item',
  template: `
    @if (item.visible | async) {
      <mat-nav-list>
        <mat-list-item
          [routerLink]="item.route"
          [routerLinkActive]="item.routerActive ? 'active-link' : ''"
          [ngStyle]="{
            width: isExpanded ? '215px' : 'unset',
          }"
        >
          @if (!item.imageURL) {
            <mat-icon
              aria-hidden="false"
              matListItemIcon
              class="material-icons-outlined"
              [matBadge]="item.badgeCount | async"
              [matBadgeHidden]="(item.badgeCount | async) === 0"
              matBadgePosition="before"
              matBadgeSize="small"
              [matBadgeColor]="item.badgeWarn ? 'warn' : 'accent'"
              >{{ item.iconText }}</mat-icon
            >
          }
          @if (isExpanded) {
            <div style="word-break: break-word; white-space: normal;">
              {{ item.text | translate }}
            </div>
          }
          @if (item.imageURL) {
            <div
              style="margin-right: 16px; border-radius: 50%; background-size: cover;background-position: 50% 50%;"
              matListItemIcon
              [style.background-image]="'url(' + item.imageURL + ')'"
              [matBadge]="item.badgeCount | async"
              [matBadgeHidden]="(item.badgeCount | async) === 0"
              matBadgePosition="before"
              matBadgeSize="small"
              [matBadgeColor]="item.badgeWarn ? 'warn' : 'accent'"
            ></div>
          }
        </mat-list-item>
      </mat-nav-list>
    }
  `,
  styleUrls: ['./navigation-item.component.scss'],
  standalone: false,
})
export class NavigationItemComponent {
  @Input() isExpanded = false;
  @Input() item: NavItem;
}
